import { render, staticRenderFns } from "./CheatingViolationInfo.vue?vue&type=template&id=4bbf26d9&scoped=true"
import script from "./CheatingViolationInfo.vue?vue&type=script&lang=js"
export * from "./CheatingViolationInfo.vue?vue&type=script&lang=js"
import style0 from "./CheatingViolationInfo.vue?vue&type=style&index=0&id=4bbf26d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf26d9",
  null
  
)

export default component.exports